import React, { useCallback, useMemo } from 'react';
import {initialState, CostReportSearchContext} from './context';
import { useAppSelector } from '../../../hooks/hooks';
import { updateCostReportSearchValue } from '../../../features/cost-report';

const CostReportSearchProvider = (props: { children: React.ReactNode }) => {
    const searchValue = useAppSelector((state) => state.costReport.filter.searchValue);

    const handleChange = useCallback((value: string) => {
        updateCostReportSearchValue(value);
    }, []);

    const config: CostReportSearchContext = useMemo(() => ({
        ...initialState,
        value: searchValue ?? initialState.value,
        change: handleChange,
    }), [handleChange, searchValue]);

    return <CostReportSearchContext.Provider value={config}>
        {props.children}
    </CostReportSearchContext.Provider>
}

export const useCostReportSearch = (): CostReportSearchContext => React.useContext(CostReportSearchContext);

export default CostReportSearchProvider;
